import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`

export const Content = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  overflow-y: auto;
  height: 100%;

  ${VerticalStyledScrollBar}
`
